import { InjectionToken } from '@angular/core';

import type { UserRepository } from '@contexts/users/domain';

export const USER_REPOSITORY = new InjectionToken<UserRepository>('UserRepository');
